export enum SupplierDetailTabs {
    Overview = 'overview',
    Addresses = 'addresses',
    Employees = 'employees',
    Conditions = 'conditions',
    Categories = 'categories',
    Units = 'units',
    Attributes = 'attributes',
    Documents = 'documents',
    Transactions = 'transactions',
    ExternalCustomerMapping = 'external-customer-mapping',
}
